import style from './NaoEncontrada.module.scss';

const NaoEncontrada = () => {
  return (
    <div><h1>404</h1></div>
  )
}

export default NaoEncontrada;